module.exports = __webpack_public_path__ + "img/icon-receive-full.cddc980e.png";